import PropTypes from "prop-types";
import { useDatosTallas } from "./useDatosTallas";
import { HeadInput } from "../../ui/HeadInput"; 
import { useEffect } from "react";

const FormDatosTallas = ({ formik }) => {
  const { getTallas, tallas } = useDatosTallas();
  useEffect(() => {
    getTallas();
  }, []);

  return (
    <>
      <div className="row mt-3">
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Pantalón *" formik={formik} html_for="talla_pantalon" datosObj="datosTallas" />
          <select id="talla_pantalon" className="form-select" name="datosTallas.talla_pantalon" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosTallas.talla_pantalon} disabled={false}>
            <option value="">Seleccione</option>
            {tallas?.pantalon?.map(({id, talla}) => {
              return (
                <option value={talla} key={id}>
                  {talla}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Polera *" formik={formik} html_for="talla_polera" datosObj="datosTallas" />
          <select id="talla_polera" className="form-select" name="datosTallas.talla_polera" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosTallas.talla_polera} disabled={false}>
            <option value="">Seleccione</option>
              {tallas?.polera?.map(({id, talla}) => {
              return (
                <option value={talla} key={id}>
                  {talla}
                </option>
              );
            })}
          </select>
        </div>

        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Camisa o blusa *" formik={formik} html_for="talla_camisablusa" datosObj="datosTallas" />
          <select id="talla_camisablusa" className="form-select" name="datosTallas.talla_camisablusa" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosTallas.talla_camisablusa} disabled={false}>
            <option value="">Seleccione</option>
            {tallas?.camisa_blusa?.map(({id, talla}) => {
              return (
                <option value={talla} key={id}>
                  {talla}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Polerón *" formik={formik} html_for="talla_poleron" datosObj="datosTallas" />
          <select id="talla_poleron" className="form-select" name="datosTallas.talla_poleron" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosTallas.talla_poleron} disabled={false}>
            <option value="">Seleccione</option>
            {tallas?.poleron?.map(({id, talla}) => {
              return (
                <option value={talla} key={id}>
                  {talla}
                </option>
              );
            })}
          </select>
        </div>

        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Chaqueta *" formik={formik} html_for="talla_chaqueta" datosObj="datosTallas" />
          <select id="talla_chaqueta" className="form-select" name="datosTallas.talla_chaqueta" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosTallas.talla_chaqueta} disabled={false}>
            <option value="">Seleccione</option>
            {tallas?.chaqueta?.map(({id, talla}) => {
              return (
                <option value={talla} key={id}>
                  {talla}
                </option>
              );
            })}
          </select>
        </div>

        <div className="col-12 col-sm-4 my-1">
        </div>
      </div>
    </>
  );
};

FormDatosTallas.propTypes = {
  formik: PropTypes.shape({
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    touched: PropTypes.object,
  }).isRequired,
};

export default FormDatosTallas;
